import { isAnyRealEstateCategory } from '@kijiji/category'
import { ResultsView } from '@kijiji/generated/graphql-types'

import { shouldAllowGridView } from '@/features/search/utils/shouldAllowGridView'

export const getSearchViewType = ({
  categoryId,
  isRadiusLocation,
  queryParamView,
  isGridViewEnabled,
  isRealEstateGridExpEnabled,
}: {
  categoryId: number
  isRadiusLocation: boolean
  queryParamView?: string | string[]
  isGridViewEnabled?: boolean
  isRealEstateGridExpEnabled?: boolean
}): ResultsView => {
  const isGridViewAllowed = isGridViewEnabled && shouldAllowGridView(categoryId)

  const realEstateGridViewEnabled =
    isRealEstateGridExpEnabled && isAnyRealEstateCategory(categoryId)
  const isViewTypeUnavailable = !queryParamView || typeof queryParamView !== 'string'

  if (isViewTypeUnavailable && (isGridViewAllowed || realEstateGridViewEnabled)) {
    return ResultsView.Grid
  }

  if (isViewTypeUnavailable) return ResultsView.List

  const viewQuery = queryParamView.toUpperCase()

  /**
   * It should only allow grid view if the toggle is enabled
   * AND on buy and sell category
   */
  if (viewQuery === ResultsView.Grid && isGridViewAllowed) {
    return ResultsView.Grid
  }

  /**
   * It should only allow map view on real estate categories
   * If it is a radius location
   */
  if (viewQuery === ResultsView.Map && isRadiusLocation && isAnyRealEstateCategory(categoryId)) {
    return ResultsView.Map
  }

  /** If we're on real estate category and the experiment is on,
   * and we're not on map view, then grid view is the only other option
   */
  if (realEstateGridViewEnabled) {
    return ResultsView.Grid
  }

  return ResultsView.List
}
